import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { CustomerTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  customerId: number;
};

type Return = {
  customerType: CustomerTypeDto | undefined;
  getCustomerType: (req: Req) => Promise<CustomerTypeDto>;
  isErrorGettingCustomerType: boolean;
  isGettingCustomerType: boolean;
};

export const useGetCustomerType = (): Return => {
  const { customersApi } = useApiClient();

  const { data, isError, isPending, mutateAsync } = useMutation<CustomerTypeDto, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const { data } = await customersApi.getCustomerType(req.customerId);
      return data.type;
    },
    mutationKey: [QueryKeyEnum.CUSTOMERS.TYPE],
  });

  return {
    customerType: data,
    getCustomerType: mutateAsync,
    isErrorGettingCustomerType: isError,
    isGettingCustomerType: isPending,
  };
};
